<template>
  <div v-if="isLoaded">
    <div
      class="mb-5"
    >
      <h3
        class="mb-2"
      >
        Campaign Theme
      </h3>
      <p
        class="mb-0"
      >
        <small>
          Apply to all creative units
        </small>
      </p>
    </div>
    <section
      class="card p-3 mb-2"
      v-if="displayLogoSection"
    >
      <h5
        class="mb-4"
      >
        <i class="fas fa-folder-open text-blue mr-2" /> Campaign Assets
      </h5>
      <logo-upload
        logo-type="master"
        :disabled="!propertiesCanBeUpdated"
        :key="selectedCreativeId"
      />
      <!-- <hr class="my-5"> -->
    </section>
    <section
      class="card p-3 mb-2"
      v-if="masterPropertiesAreFullySupported"
    >
      <h5
        class="mb-4"
      >
        <i class="fas fa-palette text-red mr-2" /> Template
      </h5>
      <div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Background
          </p>
          <base-colour-select
            class="col-6"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            @updateValue="updateProperties( 'backgroundColour', $event)"
            :disabled="!propertiesCanBeUpdated"
            :value="campaignProperties.backgroundColour"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('borderColour') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Border Colour
          </p>
          <base-colour-select
            class="col-6"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('borderColour', $event)"
            :value="campaignProperties.borderColour"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center"
          v-if="allCreativePropertiesNames.indexOf('borderWidth') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Border Width
          </p>
          <base-counter
            class="col-5"
            unit="px"
            :value="campaignProperties.borderWidth"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties( 'borderWidth', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
      </div>
      <!-- <hr class="my-5"> -->
    </section>
    <section
      class="card p-3 mb-2"
      v-if="masterPropertiesAreFullySupported"
    >
      <h5
        class="mb-4"
      >
        <i class="fas fa-font-case text-indigo mr-2" /> Font Family
      </h5>
      <div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Headline Font
          </p>
          <base-font-select
            class="col-6"
            :value="campaignProperties.headlineFontFamily"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties( 'headlineFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Weight
          </p>
          <base-font-weight-select
            class="col-6"
            @updateValue="updateProperties('headlineFontWeight', $event)"
            :disabled="!propertiesCanBeUpdated"
            :value="Number(campaignProperties.headlineFontWeight)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Colour
          </p>
          <base-colour-select
            class="col-6"
            :value="campaignProperties.headlineFontColour"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('headlineFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
      </div>
      <!-- <hr class="my-5"> -->
      <div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Body Font
          </p>
          <base-font-select
            class="col-6"
            :value="campaignProperties.bodyFontFamily"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('bodyFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Weight
          </p>
          <base-font-weight-select
            class="col-6"
            :value="Number(campaignProperties.bodyFontWeight)"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('bodyFontWeight', $event)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center"
        >
          <p
            class="mb-0 form-label"
          >
            Colour
          </p>
          <base-colour-select
            class="col-6"
            :value="campaignProperties.bodyFontColour"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('bodyFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
      </div>
      <!-- <hr class="my-5"> -->
    </section>
    <section
      class="card p-3 mb-2"
      v-if="masterPropertiesAreFullySupported"
    >
      <h5
        class="mb-4"
      >
        <i class="fas fa-arrow-pointer text-orange mr-2" /> Call to Action
      </h5>
      <div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaFontFamily') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Font
          </p>
          <base-font-select
            class="col-6"
            :value="campaignProperties.ctaFontFamily"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaFontWeight') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Weight
          </p>
          <base-font-weight-select
            class="col-6"
            @updateValue="updateProperties('ctaFontWeight', $event)"
            :disabled="!propertiesCanBeUpdated"
            :value="Number(campaignProperties.ctaFontWeight)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaFontColour') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Font Colour
          </p>
          <base-colour-select
            class="col-6"
            :value="campaignProperties.ctaFontColour"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaBackgroundColour') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Background
          </p>
          <base-colour-select
            class="col-6"
            :value="campaignProperties.ctaBackgroundColour"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaBackgroundColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaBorderColour') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Cta Border
          </p>
          <base-colour-select
            class="col-6"
            :key="properties.ctaBorderColour"
            :disabled="!propertiesCanBeUpdated"
            :value="properties.ctaBorderColour"
            @updateValue="updateProperty('ctBorderColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaFontSize') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Font Size
          </p>
          <base-counter
            class="col-5"
            unit="px"
            :min="12"
            :max="20"
            :value="campaignProperties.ctaFontSize"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaFontSize', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
          v-if="allCreativePropertiesNames.indexOf('ctaPadding') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Button Size
          </p>
          <base-slider
            :step="1"
            :min="0"
            :max="15"
            :value="Number(campaignProperties.ctaPadding)"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaPadding', $event)"
            class="col-6"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center"
          v-if="allCreativePropertiesNames.indexOf('ctaBorderRadius') !== -1"
        >
          <p
            class="mb-0 form-label"
          >
            Corner Rounding
          </p>
          <base-slider
            :step="1"
            :min="0"
            :max="25"
            :value="Number(campaignProperties.ctaBorderRadius)"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('ctaBorderRadius', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
            class="col-6"
          />
        </div>
      </div>
      <!-- <hr class="my-5"> -->
    </section>
    <section
      class="card p-3 mb-5"
      v-if="masterPropertiesAreFullySupported"
    >
      <h5
        class="mb-4 d-flex"
      >
        <i class="fas fa-scale-balanced text-teal mr-2" /> Disclaimer
        <label
          class="custom-switch-label d-flex flex-column align-self-center m-0 ml-4"
        >
          <input
            type="checkbox"
            name="custom-switch-checkbox"
            class="custom-switch-input"
            :disabled="!propertiesCanBeUpdated"
            :checked="disclaimerDisplayed"
            @click="toggleDisclaimer($event.target.checked)"
          >
          <span
            ref="custom-switch-indicator"
            class="custom-switch-indicator"
            :class="{'disabled': !propertiesCanBeUpdated}"
            :data-test="`disclaimer-toggle-${selectedArticleUuid}`"
          />
        </label>
      </h5>
      <div v-if="disclaimerDisplayed">
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Text
          </p>
          <div>
            <b-input
              id="disclaimer-text"
              placeholder="Add disclaimer text here…"
              :disabled="!propertiesCanBeUpdated"
              :value="campaignProperties.disclaimer"
              @change="updateProperties('disclaimer', $event)"
            />
          </div>
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Font
          </p>
          <base-font-select
            class="col-6"
            :value="campaignProperties.disclaimerFontFamily"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('disclaimerFontFamily', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Weight
          </p>
          <base-font-weight-select
            class="col-6"
            @updateValue="updateProperties('disclaimerFontWeight', $event)"
            :disabled="!propertiesCanBeUpdated"
            :value="Number(campaignProperties.disclaimerFontWeight)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center mb-4"
        >
          <p
            class="mb-0 form-label"
          >
            Colour
          </p>
          <base-colour-select
            class="col-6"
            :value="campaignProperties.disclaimerFontColour"
            :disabled="!propertiesCanBeUpdated"
            @updateValue="updateProperties('disclaimerFontColour', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
        <div
          class="row gutters-0 justify-content-between align-items-center"
        >
          <p
            class="mb-0 form-label"
          >
            Font Size
          </p>
          <base-counter
            class="col-5"
            unit="px"
            :min="8"
            :max="16"
            :disabled="!propertiesCanBeUpdated"
            :value="campaignProperties.disclaimerFontSize"
            @updateValue="updateProperties('disclaimerFontSize', $event)"
            @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
            @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import LogoUpload from '@/modules/content/components/CreativesPage/Sidebar/LogoUpload';
import BaseColourSelect from '@/components/BaseColourSelect';
import BaseCounter from '@/components/BaseCounter';
import BaseFontSelect from '@/components/BaseFontSelect';
import BaseFontWeightSelect from '@/components/BaseFontWeightSelect.vue';
import BaseSlider from '@/components/BaseSlider.vue';

function initialData() {
  return {
    isLoaded: false,
    disclaimerDisplayed: false,
  };
}

export default {
  name: 'MasterCreativeProperties',
  components: {
    BaseSlider,
    BaseFontWeightSelect,
    LogoUpload,
    BaseColourSelect,
    BaseCounter,
    BaseFontSelect,
  },
  data() {
    return initialData();
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'campaignProperties',
    ]),
    ...mapState('content', [
      'selectedArticleUuid',
      'selectedCreativeId',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_DRAFT,
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN,
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ACTIVE_CREATIVES,
    ]),
    allCreativePropertiesNames() {
      return [...new Set(this.GET_ACTIVE_CREATIVES.map((creative) => Object.keys(creative.properties))
        .reduce((array1, array2) => array1.concat(array2), []))];
    },
    masterPropertiesAreFullySupported() {
      return this.allCreativePropertiesNames.length > 15;
    },
    displayLogoSection() {
      return this.allCreativePropertiesNames.length > 0;
    },
    propertiesCanBeUpdated() {
      return !this.GET_IS_CAMPAIGN_READONLY;
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.GET_CAMPAIGN_PROPERTIES,
      campaignTypes.PATCH_CAMPAIGN_PROPERTIES,
    ]),
    ...mapActions('content', [
      contentTypes.FETCH_EXISTING_CREATIVES,
      contentTypes.SET_IS_SIDEBAR_INPUT_FOCUSED,
      contentTypes.TRIGGER_CREATIVE_RERENDER,
    ]),
    toggleDisclaimer(isChecked) {
      this.disclaimerDisplayed = isChecked;
      this.updateProperties('disclaimerDisplay', isChecked);
    },
    async updateProperties(propertyName, newValue) {
      const payload = {
        campaignId: this.campaign.id,
        advertiserId: this.campaign.advertiserId,
        properties: {
          [propertyName]: newValue,
        },
      };
      await this.PATCH_CAMPAIGN_PROPERTIES(payload);
      this.TRIGGER_CREATIVE_RERENDER();
      this.FETCH_EXISTING_CREATIVES();
    },
  },
  async created() {
    const { advertiserId, campaignId } = this.$route.params;
    const payload = {
      advertiserId: advertiserId ?? this.campaign.advertiserId,
      campaignId: campaignId ?? this.campaign.id,
      type: this.type,
    };
    await this.GET_CAMPAIGN_PROPERTIES(payload);
    this.disclaimerDisplayed = this.campaignProperties.disclaimerDisplay === 'true';
    this.isLoaded = true;
  },
};
</script>
<style lang="scss" scoped>
span.disabled {
  cursor: not-allowed !important;
}
</style>
